const CalendarCheck = ({ width = 24, height = 24, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M9.66992 1V3H15.6699V1H17.6699V3H21.6699C21.9351 3 22.1895 3.10536 22.377 3.29289C22.5646 3.48043 22.6699 3.73478 22.6699 4V20C22.6699 20.2652 22.5646 20.5196 22.377 20.7071C22.1895 20.8946 21.9351 21 21.6699 21H3.66992C3.40471 21 3.15035 20.8946 2.96282 20.7071C2.77528 20.5196 2.66992 20.2652 2.66992 20V4C2.66992 3.73478 2.77528 3.48043 2.96282 3.29289C3.15035 3.10536 3.40471 3 3.66992 3H7.66992V1H9.66992ZM20.6699 10H4.66992V19H20.6699V10ZM15.7059 11.136L17.1199 12.55L12.1699 17.5L8.63392 13.964L10.0499 12.55L12.1709 14.672L15.7069 11.136H15.7059ZM7.66992 5H4.66992V8H20.6699V5H17.6699V6H15.6699V5H9.66992V6H7.66992V5Z"
        fill={color}
      />
    </svg>
  )
}

export default CalendarCheck
